import { computed, ref } from 'vue';

import { PortfolioPerformanceTabs } from '../enums/portfolio-performance-tabs.enum';
import { PortfolioStatisticsFilter } from '../enums/portfolio-statistics-filter.enum';
import { usePortfolioColdUnitsQuery } from '../queries/portfolio-cold-units.query';
import { usePortfolioHotUnitsQuery } from '../queries/portfolio-hot-units.query';

export function useUnitPerformanceComposable(initialTab?: PortfolioPerformanceTabs) {
  const tabs = Object.values(PortfolioPerformanceTabs);
  const activeTab = ref<PortfolioPerformanceTabs>(initialTab || tabs[0]);
  const dateFilter = ref(PortfolioStatisticsFilter.LAST_7_DAYS);

  const portfolioHotUnitsQuery = usePortfolioHotUnitsQuery(dateFilter);
  const portfolioColdUnitsQuery = usePortfolioColdUnitsQuery(dateFilter);

  const activeQuery = computed(() =>
    activeTab.value === PortfolioPerformanceTabs.Cold ? portfolioColdUnitsQuery : portfolioHotUnitsQuery,
  );
  const isPending = computed(() => activeQuery.value.isPending);
  const data = computed(() => activeQuery.value.data.value?.units || []);

  return {
    activeQuery,
    isPending,
    data,
    activeTab,
    tabs,
    setActiveTab(tab: PortfolioPerformanceTabs) {
      activeTab.value = tab;
    },
  };
}
